'use client';

import * as React from 'react';
import classNames from 'classnames';
import OverlayTitle from '@/components/ui/LayoutOverlay/OverlayTitle';
import Block, { IBlockProps } from '@/components/ui/Block';
import './styles.scss';

export interface ILayoutOverlayProps {
  /** className to append */
  className?: string;
  /** Container size */
  size?: 'default' | 'max' | 'wide' | 'medium' | 'small' | 'mobilemenu' | 'filter';
  /** Children to render */
  children?: React.ReactNode;
  /** Title */
  title?: React.ReactNode;
  /** Title theme */
  titleTheme?: IBlockProps['theme'];
  /** Close event */
  onClose?: () => void;
  /** Go back in stack */
  goBack?: () => void;
  /** Footer */
  footer?: React.ReactNode;
}

/**
 * Main wrapper for overlay content.
 */
const LayoutOverlay: React.FunctionComponent<ILayoutOverlayProps> = (props) => {
  return (
    <div
      className={classNames(
        'layout-overlay',
        {
          ['size-default']: props.size === 'default' || !props.size,
          ['size-max']: props.size === 'max',
          ['size-wide']: props.size === 'wide',
          ['size-medium']: props.size === 'medium',
          ['size-small']: props.size === 'small',
          ['size-mobilemenu']: props.size === 'mobilemenu',
          ['size-filter']: props.size === 'filter',
        },
        props.className,
      )}
    >
      {props.title && props.onClose && (
        <Block
          className={'layout-overlay__title'}
          theme={props.titleTheme || 'lightest'}
          width="full"
        >
          <OverlayTitle
            title={props.title}
            onClose={props.onClose}
            goBack={props.goBack}
          />
        </Block>
      )}
      <div className={'layout-overlay__inner'}>
        <div className={classNames('layout-overlay__content')}>{props.children}</div>
      </div>
      {props.footer && <div className={'layout-overlay__footer'}>{props.footer}</div>}
    </div>
  );
};

LayoutOverlay.displayName = 'LayoutOverlay';

export default LayoutOverlay;
